var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          ref: "modalbody",
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.hideModal()
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    attrs: { flat: "", round: "", dense: "", icon: "close" }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("topic") + ": " + _vm.topic.title))
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-list",
                      [
                        _c(
                          "q-item",
                          { attrs: { dense: "", multiline: "" } },
                          [
                            _vm.topic.avatar
                              ? _c("q-item-side", {
                                  staticClass: "q-pa-xs",
                                  attrs: { avatar: _vm.topic.avatar }
                                })
                              : _c("q-item-side", {
                                  staticClass: "q-pa-xs",
                                  attrs: { avatar: _vm.getPlaceholderAvatar }
                                }),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  { attrs: { sublabel: "", lines: "2" } },
                                  [
                                    _vm.$q.platform.is.desktop
                                      ? _c(
                                          "span",
                                          { staticClass: "text-light" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("added_by") + " ")
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "text-italic text-bold" },
                                      [_vm._v(_vm._s(_vm.topic.author))]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item-side",
                              { attrs: { right: "" } },
                              [
                                _c("q-item-tile", { attrs: { stamp: "" } }, [
                                  _vm.$q.platform.is.desktop
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("created_in") + ": ")
                                        )
                                      ])
                                    : _vm._e(),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.topic.updated_date))
                                  ])
                                ]),
                                _c(
                                  "q-item-tile",
                                  [
                                    _vm.topic.report
                                      ? _c(
                                          "q-btn",
                                          {
                                            staticClass: "q-pa-sm",
                                            attrs: {
                                              flat: "",
                                              rounded: "",
                                              color: "negative",
                                              icon: "fas fa-flag alt"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.cancel_report_topic = true
                                              }
                                            }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(
                                                _vm._s(
                                                  this.$t("topic_reported")
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          { attrs: { dense: "", multiline: "" } },
                          [
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-center text-bold",
                                    attrs: { label: "", lines: "1" }
                                  },
                                  [_vm._v(_vm._s(_vm.topic.title))]
                                ),
                                _vm.markdown_enabled
                                  ? _c("viewer", {
                                      staticClass: "reply q-pt-xs",
                                      attrs: { text: _vm.renderQuestion }
                                    })
                                  : _vm._e(),
                                !_vm.markdown_enabled
                                  ? _c("p", { staticClass: "reply q-pt-xs" }, [
                                      _vm._v(_vm._s(_vm.renderQuestion))
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          { attrs: { sparse: "" } },
                          [
                            _c(
                              "q-item-main",
                              { staticClass: "q-mt-md" },
                              [
                                _c("p", { staticClass: "caption" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("topic_status")))
                                  ])
                                ]),
                                _c("q-btn-toggle", {
                                  attrs: {
                                    "toggle-color": _vm.getColorStatus(
                                      _vm.topic.status
                                    ),
                                    options: _vm.topic_statuses
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setTopicStatus(
                                        _vm.topic.status
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.topic.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.topic, "status", $$v)
                                    },
                                    expression: "topic.status"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _vm.answers && _vm.answers.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-12 q-my-md text-center"
                      },
                      [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("answers").toUpperCase()))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.answers && _vm.answers.length > 0
                  ? _c(
                      "div",
                      { ref: "answersBody", staticClass: "col-12" },
                      _vm._l(_vm.answers, function(answer, index) {
                        return _c(
                          "q-list",
                          { key: index, staticClass: "text-align-center" },
                          [
                            _c(
                              "q-item",
                              { attrs: { dense: "", multiline: "" } },
                              [
                                answer.avatar
                                  ? _c("q-item-side", {
                                      staticClass: "q-pa-xs",
                                      attrs: { avatar: answer.avatar }
                                    })
                                  : _c("q-item-side", {
                                      staticClass: "q-pa-xs",
                                      attrs: {
                                        avatar: _vm.getPlaceholderAvatar
                                      }
                                    }),
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "", lines: "2" } },
                                      [
                                        _vm.$q.platform.is.desktop
                                          ? _c(
                                              "span",
                                              { staticClass: "text-light" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("replied_by") + " "
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-italic text-bold"
                                          },
                                          [_vm._v(_vm._s(answer.author))]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item-side",
                                  { attrs: { right: "" } },
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { stamp: "" } },
                                      [
                                        _vm.$q.platform.is.desktop
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("replied_in") + ": "
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(answer.updated_date) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-item-tile",
                                      [
                                        answer.report
                                          ? _c(
                                              "q-btn",
                                              {
                                                staticClass: "q-pa-sm",
                                                attrs: {
                                                  flat: "",
                                                  rounded: "",
                                                  color: "negative",
                                                  icon: "fas fa-flag alt"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setAnswerToCancelReport(
                                                      answer
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("answer_reported")
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "q-item-main",
                                  [
                                    _c("viewer", {
                                      staticClass: "reply q-pt-xs",
                                      attrs: { text: answer.answer }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              { attrs: { sparse: "" } },
                              [
                                _c(
                                  "q-item-main",
                                  { staticClass: "q-mt-md" },
                                  [
                                    _c("p", { staticClass: "caption" }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.$t("answer_status")))
                                      ])
                                    ]),
                                    _c("q-btn-toggle", {
                                      attrs: {
                                        "toggle-color": _vm.getColorStatus(
                                          answer.status
                                        ),
                                        options: _vm.answer_statuses
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.setAnswerStatus(answer)
                                        }
                                      },
                                      model: {
                                        value: answer.status,
                                        callback: function($$v) {
                                          _vm.$set(answer, "status", $$v)
                                        },
                                        expression: "answer.status"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e()
              ]),
              _c(
                "q-toolbar",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("q-btn", {
                    staticClass: "q-mx-sm",
                    attrs: { color: "negative", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideModal()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.cancel_report_topic = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("confirm") },
                    on: { click: _vm.cancelTopicReport }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.cancel_report_topic,
            callback: function($$v) {
              _vm.cancel_report_topic = $$v
            },
            expression: "cancel_report_topic"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("uncheck_reported_topic")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_uncheck_reported_topic")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.cancel_report_answer = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("confirm") },
                    on: {
                      click: function($event) {
                        return _vm.cancelAnswerReport(_vm.answer_report_id)
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.cancel_report_answer,
            callback: function($$v) {
              _vm.cancel_report_answer = $$v
            },
            expression: "cancel_report_answer"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("uncheck_reported_answer")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_uncheck_reported_answer")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }